<template lang="pug">
  Header(fixed)
    SidebarToggler.d-lg-none(display="md" mobile)
    SidebarToggler.d-md-down-none(display="lg")
    b-navbar-brand(to="/account/account_list").justify-content-start
      span.navbar-brand-full {{ $t("message.app.full") }}
      span.navbar-brand-minimized {{ $t("message.app.minimized") }}
    b-navbar-nav.ml-auto
      //- NavbarLanguage.d-lg-none
      AsideToggler.aside.d-md-down-none(display="lg")
    vue-snotify
</template>

<script>
import { Header, SidebarToggler, AsideToggler } from "@/library/coreui";
import NavbarLanguage from "@/library/NavbarLanguage";

export default {
  components: {
    Header,
    SidebarToggler,
    NavbarLanguage,
    AsideToggler
  }
};
</script>
